export default "__VITE_ASSET__DrdSyeuK__"